import React from "react";
import { Phone, MessageCircle } from "lucide-react";
const FloatingButtons = () => {
  return (
    <div className="fixed right-5 bottom-5 z-[9999] flex flex-col gap-3">
      <a
        href="https://wa.me/919451887217"
        target="_blank"
        rel="noreferrer"
        className="w-12 h-12 rounded-full bg-green-500 text-white flex items-center justify-center shadow-xl hover:scale-110 transition-all duration-300"
        aria-label="WhatsApp"
      >
        <MessageCircle size={20} />
      </a>
      <a
        href="tel:+919451887217"
        className="w-12 h-12 rounded-full bg-[#071A52] text-[#FFD700] flex items-center justify-center shadow-xl hover:scale-110 transition-all duration-300"
        aria-label="Call Now"
      >
        <Phone size={20} />
      </a>
    </div>
  );
};
export default FloatingButtons;